export enum FilterTestIds {
  APPLY_FILTER_BUTTON = 'apply-filter-button',
  CHIP_PREFIX = 'filter-chip-',
  CLEAR_FILTER_BUTTON = 'clear-filter-button',
  CLEAR_ALL_FILTERS_BUTTON = 'clear-all-filters-button',
  OPEN_ADD_FILTERS_BUTTON = 'open-add-filters-button',
  BRANDS_FIXED_BUTTON = 'brands-fixed-filter-button',
  STATUS_FIXED_BUTTON = 'status-fixed-filter-button',
  WRAPPER = 'filter-wrapper',
  SECTION_PREFIX = 'filter-section-',
  OPTION_PREFIX = 'filter-option-',
  DATE_FIELD_PREFIX = 'date-filter-field-',
}
